export const PERMISSIONS = {
	VIEW_MANAGE_EMP_REQUEST: 'ROLE_VIEW_MANAGE_EMP_REQUEST',
	APPROVE_EMP_REQUEST: 'ROLE_APPROVE_EMP_REQUEST',
	HR_VIEW_EMPLOYEES: 'ROLE_HR_VIEW_EMPLOYEES',
	HR_UPDATE_EMPLOYEES: 'ROLE_HR_UPDATE_EMPLOYEES',
	HR_MANAGE_ATTENDANCE: 'ROLE_HR_MANAGE_ATTENDANCE',
	HR_MANAGE_LEAVE_APPROVALS: 'ROLE_HR_MANAGE_LEAVE_APPROVALS',
	HR_MANAGE_ATTENDANCE_APPROVALS: 'ROLE_HR_MANAGE_ATTENDANCE_APPROVALS',
	HR_MANAGE_PANS: 'ROLE_HR_MANAGE_PANS',
	HR_MANAGE_TRAININGS: 'ROLE_HR_MANAGE_TRAININGS',
	HR_MANAGE_LEAVE_ALLOCATIONS: 'ROLE_HR_MANAGE_LEAVE_ALLOCATIONS',
	VIEW_LOANS_APPROVAL: 'ROLE_VIEW_LOANS_APPROVAL',
	TAKE_ACTION_LOANS_APPROVAL: 'ROLE_TAKE_ACTION_LOANS_APPROVAL',
	VIEW_UNIFORMS_APPROVAL: 'ROLE_VIEW_UNIFORMS_APPROVAL',
	TAKE_ACTION_UNIFORMS_APPROVAL: 'ROLE_TAKE_ACTION_UNIFORMS_APPROVAL',
	HR_MANAGE_COMPANIES: 'ROLE_HR_MANAGE_COMPANIES',
	HR_MANAGE_HOLIDAYS: 'ROLE_HR_MANAGE_HOLIDAYS',
	HR_MANAGE_DEPARTMENTS: 'ROLE_HR_MANAGE_DEPARTMENTS',
	HR_MANAGE_JOB_LEVELS: 'ROLE_HR_MANAGE_JOB_LEVELS',
	HR_MANAGE_SHIFTS: 'ROLE_HR_MANAGE_SHIFTS',
	HR_MANAGE_LEAVES: 'ROLE_HR_MANAGE_LEAVES',
	HR_MANAGE_ITEMS: 'ROLE_HR_MANAGE_ITEMS',
	CREATE_PRF: 'ROLE_CREATE_PRF',
	APPROVAL_PRF: 'ROLE_APPROVAL_PRF',
	VIEW_PRF_LIST: 'ROLE_VIEW_PRF_LIST',
	VIEW_JO_LIST: 'ROLE_VIEW_JO_LIST',
	MANAGE_PRE_EMPLOYMENT_REQMTS: 'ROLE_MANAGE_PRE-EMPLOYMENT_REQMTS',
	MANAGE_ONBOARDING_CHECKLIST: 'ROLE_MANAGE_ONBOARDING_CHECKLIST',
	VIEW_SCREENING_LIST: 'ROLE_VIEW_SCREENING_LIST',
	CREATE_INTERVIEW: 'ROLE_CREATE_INTERVIEW',
	GENERATE_PREEMPLOYMENT: 'ROLE_GENERATE_PREEMPLOYMENT',
	REVIEW_PREEMPLOYMENT: 'ROLE_REVIEW_PREEMPLOYMENT',
	VIEW_HIRING_LIST: 'ROLE_VIEW_HIRING_LIST',
	CREATE_JOB_OFFER: 'ROLE_CREATE_JOB_OFFER',
	UPDATE_JOB_OFFER: 'ROLE_UPDATE_JOB_OFFER',
	SEND_JOB_OFFER: 'ROLE_SEND_JOB_OFFER',
	APPROVAL_JOB_OFFER: 'ROLE_APPROVAL_JOB_OFFER',
	CREATE_CONTRACT_NONSG: 'ROLE_CREATE_CONTRACT_NONSG',
	CANCEL_CONTRACT_NONSG: 'ROLE_CANCEL_CONTRACT_NONSG',
	CREATE_CONTRACT_SG: 'ROLE_CREATE_CONTRACT_SG',
	UPDATE_CONTRACT_SG: 'ROLE_UPDATE_CONTRACT_SG',
	SEND_CONTRACT_SG: 'ROLE_SEND_CONTRACT_SG',
	APPROVAL_CONTRACT_SG: 'ROLE_APPROVAL_CONTRACT_SG',
	CREATE_AO: 'ROLE_CREATE_AO',
	CREATE_EL_SG: 'ROLE_CREATE_EL_SG',
	VIEW_ONBOARDING_LIST: 'ROLE_VIEW_ONBOARDING_LIST',
	CREATE_ONBOARDING_SCHED: 'ROLE_CREATE_ONBOARDING_SCHED',
	RESCHED_ONBOARDING_INVITE: 'ROLE_RESCHED_ONBOARDING_INVITE',
	VIEW_ONBOARDING_ATTENDANCE: 'ROLE_VIEW_ONBOARDING_ATTENDANCE',
	UPDATE_ONBOARDING_ATTENDANCE: 'ROLE_UPDATE_ONBOARDING_ATTENDANCE',
	VIEW_RECRUITMENT_LIST: 'ROLE_VIEW_RECRUITMENT_LIST',
	RECOMMEND_APPLICANT: 'ROLE_RECOMMEND_APPLICANT',
	VIEW_OFFENSE_REPORT: 'ROLE_VIEW_OFFENSE_REPORT',
	CREATE_OFFENSE_REPORT: 'ROLE_CREATE_OFFENSE_REPORT',
	UPDATE_OFFENSE_REPORT: 'ROLE_UPDATE_OFFENSE_REPORT',
	TAKE_ACTION_OFFENSE_REPORT: 'ROLE_TAKE_ACTION_OFFENSE_REPORT',
	VIEW_FIELD_EMPLOYEES: 'ROLE_VIEW_FIELD_EMPLOYEES',
	VIEW_APPOINTMENT_ORDER: 'ROLE_VIEW_APPOINTMENT_ORDER',
	CREATE_APPOINTMENT_ORDER: 'ROLE_CREATE_APPOINTMENT_ORDER',
	CREATE_RELIEVE_ORDER: 'ROLE_CREATE_RELIEVE_ORDER',
	UPDATE_APPOINTMENT: 'ROLE_UPDATE_APPOINTMENT',
	VIEW_PAF: 'ROLE_VIEW_PAF',
	CREATE_PAF: 'ROLE_CREATE_PAF',
	TAKE_ACTION_PAF: 'ROLE_TAKE_ACTION_PAF',
	MANAGE_CLUSTERS: 'ROLE_MANAGE_CLUSTERS',
	MANAGE_AREAS: 'ROLE_MANAGE_AREAS',
	MANAGE_CLIENTS: 'ROLE_MANAGE_CLIENTS',
	MANAGE_OFFENSES: 'ROLE_MANAGE_OFFENSES',
	MANAGE_ITEMS: 'ROLE_MANAGE_ITEMS',
	OPS_ADMIN: 'ROLE_OPS_ADMIN',
	SUPERVISOR_VIEW: 'ROLE_SUPERVISOR_VIEW',
	SUPERVISOR_TAKE_ACTION: 'ROLE_SUPERVISOR_TAKE_ACTION',
	GENERATE_ATTENDANCE_REPORT: 'ROLE_GENERATE_ATTENDANCE_REPORT',
	HR_ADMIN: 'ROLE_HR_ADMIN',
	GENERATE_MANDATORY_REPORT: 'ROLE_GENERATE_MANDATORY_REPORT',
	GENERATE_LEAVES_REPORT: 'ROLE_GENERATE_LEAVES_REPORT',
	OFFBOARDING_MAINTENANCE: 'ROLE_OFFBOARDING_MAINTENANCE',
	HR_VIEW_OFFBOARDING: 'ROLE_HR_VIEW_OFFBOARDING',
	HR_TAKE_ACTION_OFFBOARDING: 'ROLE_HR_TAKE_ACTION_OFFBOARDING',
	HR_MANAGE_OFFBOARDING: 'ROLE_HR_MANAGE_OFFBOARDING',
	MANAGE_BENEFIT_LIST: 'ROLE_MANAGE_BENEFIT_LIST',
	MANAGE_HOLIDAY_RATE_LIST: 'ROLE_MANAGE_HOLIDAY_RATE_LIST',
	MANAGE_OT_RATE_LIST: 'ROLE_MANAGE_OT_RATE_LIST',
	MANAGE_SSS_LIST: 'ROLE_MANAGE_SSS_LIST',
	VIEW_BENEFIT_LIST: 'ROLE_VIEW_BENEFIT_LIST',
	VIEW_HOLIDAY_RATE_LIST: 'ROLE_VIEW_HOLIDAY_RATE_LIST',
	VIEW_OT_RATE_LIST: 'ROLE_VIEW_OT_RATE_LIST',
	VIEW_SSS_LIST: 'ROLE_VIEW_SSS_LIST',

	VIEW_GSIS_LIST: 'ROLE_VIEW_GSIS_LIST',
	MANAGE_GSIS_LIST: 'ROLE_MANAGE_GSIS_LIST',
	VIEW_WITHHOLDING_TAX_LIST: 'ROLE_VIEW_WITHHOLDING_TAX_LIST',
	MANAGE_WITHHOLDING_TAX_LIST: 'ROLE_MANAGE_WITHHOLDING_TAX_LIST',
	VIEW_ALLOWANCE_LIST: 'ROLE_VIEW_ALLOWANCE_LIST',
	MANAGE_ALLOWANCE_LIST: 'ROLE_MANAGE_ALLOWANCE_LIST',
	VIEW_ANNUAL_TAX_LIST: 'ROLE_MANAGE_ANNUAL_TAX_LIST',
	MANAGE_ANNUAL_TAX_LIST: 'ROLE_MANAGE_ANNUAL_TAX_LIST',

	VIEW_PHILHEALTH_LIST: 'ROLE_VIEW_PHILHEALTH_LIST',
	MANAGE_PHILHEALTH_LIST: 'ROLE_MANAGE_PHILHEALTH_LIST',
	VIEW_CTPA_TAX_LIST: 'ROLE_VIEW_CTPA_TAX_LIST',
	MANAGE_CTPA_TAX_LIST: 'ROLE_MANAGE_CTPA_TAX_LIST',
	VIEW_REST_DAY_RATE_LIST: 'ROLE_VIEW_REST_DAY_RATE_LIST',
	MANAGE_REST_DAY_RATE_LIST: 'ROLE_MANAGE_REST_DAY_RATE_LIST',
	VIEW_NIGHT_DIFF_LIST: 'ROLE_VIEW_NIGHT_DIFF_LIST',
	MANAGE_NIGHT_DIFF_LIST: 'ROLE_MANAGE_NIGHT_DIFF_LIST',
	VIEW_PAGIBIG_LIST: 'ROLE_VIEW_PAGIBIG_LIST',
	MANAGE_PAGIBIG_LIST: 'ROLE_MANAGE_PAGIBIG_LIST',

};

export const NO_PERMISSION_REDIRECT = { redirectTo: '/auth/access' };

export const MANAGE_EMPLOYEE_REQUEST = [
	PERMISSIONS.VIEW_MANAGE_EMP_REQUEST,
	PERMISSIONS.APPROVE_EMP_REQUEST
];
export const MANAGE_EMPLOYEES = [
	PERMISSIONS.HR_ADMIN,
	PERMISSIONS.HR_VIEW_EMPLOYEES,
	PERMISSIONS.HR_UPDATE_EMPLOYEES
];
export const MANAGE_LOANS_APPROVAL = [
	PERMISSIONS.VIEW_LOANS_APPROVAL,
	PERMISSIONS.TAKE_ACTION_LOANS_APPROVAL
];
export const MANAGE_UNIFORMS_APPROVAL = [
	PERMISSIONS.VIEW_UNIFORMS_APPROVAL,
	PERMISSIONS.TAKE_ACTION_UNIFORMS_APPROVAL
];

export const MANAGE_PERSONNEL_REQUISITION = [
	PERMISSIONS.CREATE_PRF,
	PERMISSIONS.APPROVAL_PRF,
	PERMISSIONS.VIEW_PRF_LIST
];
export const MANAGE_PRE_EMPLOYMENT_REQUIREMENTS = [
	PERMISSIONS.MANAGE_PRE_EMPLOYMENT_REQMTS,
	PERMISSIONS.MANAGE_ONBOARDING_CHECKLIST
];
export const MANAGE_SCREENING = [
	PERMISSIONS.VIEW_SCREENING_LIST,
	PERMISSIONS.CREATE_INTERVIEW,
	PERMISSIONS.GENERATE_PREEMPLOYMENT,
	PERMISSIONS.REVIEW_PREEMPLOYMENT
];
export const MANAGE_HIRING = [
	PERMISSIONS.VIEW_HIRING_LIST,
	PERMISSIONS.CREATE_JOB_OFFER,
	PERMISSIONS.UPDATE_JOB_OFFER,
	PERMISSIONS.SEND_JOB_OFFER,
	PERMISSIONS.APPROVAL_JOB_OFFER,
	PERMISSIONS.CREATE_CONTRACT_NONSG,
	PERMISSIONS.CANCEL_CONTRACT_NONSG,
	PERMISSIONS.CREATE_CONTRACT_SG,
	PERMISSIONS.UPDATE_CONTRACT_SG,
	PERMISSIONS.SEND_CONTRACT_SG,
	PERMISSIONS.APPROVAL_CONTRACT_SG,
	PERMISSIONS.CREATE_AO,
	PERMISSIONS.CREATE_EL_SG
];
export const MANAGE_ONBOARDING_LIST = [
	PERMISSIONS.VIEW_ONBOARDING_LIST,
	PERMISSIONS.CREATE_ONBOARDING_SCHED,
	PERMISSIONS.RESCHED_ONBOARDING_INVITE
];
export const MANAGE_ONBOARDING_ATTENDANCE = [
	PERMISSIONS.VIEW_ONBOARDING_ATTENDANCE,
	PERMISSIONS.UPDATE_ONBOARDING_ATTENDANCE
];
export const MANAGE_RECRUITING_LIST = [
	PERMISSIONS.VIEW_RECRUITMENT_LIST,
	PERMISSIONS.RECOMMEND_APPLICANT
];

export const MANAGE_OFFENSE_REPORTS = [
	PERMISSIONS.VIEW_OFFENSE_REPORT,
	PERMISSIONS.CREATE_OFFENSE_REPORT,
	PERMISSIONS.UPDATE_OFFENSE_REPORT,
	PERMISSIONS.TAKE_ACTION_OFFENSE_REPORT
];
export const MANAGE_APPOINTMENT_ORDERS = [
	PERMISSIONS.VIEW_APPOINTMENT_ORDER,
	PERMISSIONS.CREATE_APPOINTMENT_ORDER,
	PERMISSIONS.CREATE_RELIEVE_ORDER,
	PERMISSIONS.UPDATE_APPOINTMENT
];
export const MANAGE_PAFS = [
	PERMISSIONS.VIEW_PAF,
	PERMISSIONS.CREATE_PAF,
	PERMISSIONS.TAKE_ACTION_PAF
];

export const HR_ADMIN = [PERMISSIONS.HR_ADMIN];

export const MANAGE_OFFBOARDING_LIST = [
	PERMISSIONS.HR_VIEW_OFFBOARDING,
	PERMISSIONS.HR_TAKE_ACTION_OFFBOARDING
];
